import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  title = 'velzon';

  ngOnInit(): void {
    // Set default theme attributes for pages outside LayoutComponent (auth, landing)
    document.documentElement.setAttribute('data-theme', 'default');
    document.documentElement.setAttribute('data-bs-theme', 'light');
    document.documentElement.setAttribute('data-layout', 'vertical');
  }
}
